module.exports = __webpack_public_path__ + "static/opener-text-f688142e3b257e99bbcc6c593374a1a0.png";